module.exports = __webpack_public_path__ + "img/icon_dialog_svip_level5.f06929ab.png";